import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';

import { withTrackedSceneView } from '@portal/common/services/google-analytics';

import { getSessionAccount } from '../store/session/selectors';
import { SIGN_IN_PATH } from './paths';

interface ProtectedRouteProps {
    onLogOut?: () => void;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ onLogOut }) => {
    const isAuthenticated = !!useSelector(getSessionAccount);
    const { pathname, search, hash } = useLocation();

    if (!isAuthenticated) {
        const requestedPath = `${pathname}${search}${hash}`;
        const redirectPath =
            onLogOut || requestedPath === '/'
                ? SIGN_IN_PATH
                : `${SIGN_IN_PATH}?${new URLSearchParams({ back: requestedPath }).toString()}`;

        return <Navigate to={redirectPath} replace />;
    }

    return <Outlet />;
};

export default withTrackedSceneView(ProtectedRoute);
